import { StrictMode } from "react";
import { Provider } from "react-redux";
import { initMarkerIo } from "@app/utils/marker-io";
import { JwtAuthProvider } from "@app/providers/jwt-auth-provider";
import { RbacProvider } from "@its-engineering-and-development/rbac-react";
import { GoogleTagManagerProvider, NotificationProvider, ThemeProvider } from "@its-engineering-and-development/ui-foundation/providers";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
// Framework styles
import "@its-engineering-and-development/ui-foundation/styles/globals.css";
import { expenseAdminPermissionResolver, expenseAdminTokenSource } from "@/auth";
import { App } from "./App";
import { store } from "./store";
// App-specific styles
import "./styles/app.css";

// Keep in sync with the <noscript> fallback in index.html.
const GTM_CONTAINER_ID = "GTM-WQQ8G7GV";

initMarkerIo();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <GoogleTagManagerProvider containerId={GTM_CONTAINER_ID}>
            <Provider store={store}>
                <BrowserRouter basename={import.meta.env.BASE_URL}>
                    <ThemeProvider defaultColorMode="light" storageKey="expense-admin-color-mode-light-only">
                        <NotificationProvider>
                            <JwtAuthProvider>
                                <RbacProvider tokenSource={expenseAdminTokenSource} resolver={expenseAdminPermissionResolver}>
                                    <App />
                                </RbacProvider>
                            </JwtAuthProvider>
                        </NotificationProvider>
                    </ThemeProvider>
                </BrowserRouter>
            </Provider>
        </GoogleTagManagerProvider>
    </StrictMode>,
);
